module.exports = __webpack_public_path__ + "static/media/clear_way.625f2b39.png";